import React from "react";
import StyledInput from "../styledInput/StyledInput";

/**
 * Block component for managing PDNS code settings per company
 * Allows selecting which companies should have PDNS code in Peopulse export
 */
function PdnsBlock({ companies, isWaiting, onPdnsChange }) {
  const selectedCount = companies.filter((c) => c.isPdns).length;

  return (
    <div className="py-3 px-4 flex justify-between gap-4 items-center">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col">
          <div className="font-bold">
            Ajout du code PDNS dans le fichier peopulse
          </div>
          <div>
            Une ligne PDNS sera ajoutée avec la valeur 1.0 pour chaque jour
            travaillé
          </div>
        </div>

        <div className="flex flex-col max-w-[330px]">
          {isWaiting ? (
            <div className="animate-pulse">
              <div className="h-12 bg-gray-200 rounded w-full"></div>
            </div>
          ) : (
            <StyledInput
              type="selectMultipleCheckbox"
              value={`${selectedCount} ${selectedCount === 1 ? "établissement" : "établissements"}`}
              list={companies.map((c) => ({
                value: c._id,
                label: c.name,
                checked: c.isPdns,
                id: c._id,
              }))}
              onChange={onPdnsChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PdnsBlock;
